var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('picture-input',{ref:"invoiceLogoInput",style:({border: '2px solid rgba(0,0,0,0.06)'}),attrs:{"accept":"image/jpeg, image/png","custom-strings":{
    drag: 'Drag your logo here or click to upload'
  },"zIndex":0,"alertOnError":false,"crop":false,"prefill":_vm.invoiceLogoFile,"customStrings":{'change': 'Change Logo'},"hideChangeButton":_vm.hideChangeButton},on:{"change":_vm.onLogoChange}})}
var staticRenderFns = []

export { render, staticRenderFns }